import { ajax, prefix } from './common';

export async function getJobListings() {
  return await ajax({
    url: prefix + '/job-listings'
  });
}